<template>
  <div class="d-flex align-center param-norm">
    <span class="pos ml-1" :class="{ error: belowNorm }"></span>
    <div class="min-value ml-1">{{ min }}</div>

    <div class="d-flex align-center norm-indicator">
      <span class="ml-1">[</span>
      <span class="pos ml-1" v-for="item in normalIndex" :key="item.uuid" :class="{ success: item.select }" />
      <span class="ml-1">]</span>
    </div>

    <div class="max-value ml-1">{{ max }}</div>
    <span class="pos ml-1" :class="{ error: aboveNorm }"></span>
  </div>
</template>

<script>
import { uniqueId } from "lodash/util";

export default {
  name: "MedParamNorm",

  props: {
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    iteration: 5,
  }),

  computed: {
    belowNorm() {
      return this.value < this.min;
    },

    aboveNorm() {
      return this.value > this.max;
    },

    normalIndex() {
      const normInterval = this.max - this.min;
      const scale = normInterval / this.iteration;
      const position = Math.floor((this.value - this.min) / scale);

      return []
        .constructor(this.iteration)
        .fill()
        .map((item, idx) => ({
          uuid: uniqueId(),
          index: idx,
          select: idx === position,
        }));
    },
  },
};
</script>

<style scoped>
.pos {
  display: block;
  background-color: #ccc;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>
